export default __webpack_public_path__ + "334f6b6bbf052568e20aae9f9b04d08f.png";